import { render, staticRenderFns } from "./category_list.vue?vue&type=template&id=b7cb4fd2&scoped=true"
import script from "./category_list.vue?vue&type=script&lang=js"
export * from "./category_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7cb4fd2",
  null
  
)

export default component.exports